import { gql } from '@apollo/client';

export const HAS_ORDER_QUERY = gql`
  query HasOrder($input: HasOrderInput!) {
    hasOrder(input: $input)
  }
`;
